import { Injectable } from '@angular/core';
import '../../assets/js/cnscx-api.js';

declare const jwtApi: any;

@Injectable({
    providedIn: 'root'
})
export class FingerprintService {

  async  identify(cnpj) {
  const api = new jwtApi.BrowserIdentifier();
  
    return await api.identifyDevice(cnpj).then((ret) => {
        let msg;
        switch (ret.result) {
            case jwtApi.IdPost.SUCCESS: msg = 'Operação de identificação bem sucedida'; break;
            case jwtApi.IdPost.TOKEN_NOT_FOUND: msg = 'CNPJ não encontrado no storage'; break;
            case jwtApi.IdPost.INVALID_TOKEN: msg = 'Valor encontrado não é um Token JWT válido para o SEFIP'; break;
            case jwtApi.IdPost.UNKNOWN_TOKEN: msg = 'Claim name do token não corresponde à chave do storage'; break;
            case jwtApi.IdPost.EXPIRED_TOKEN: msg = 'Token expirado';
        }          
         return ret.device;
    });
  }
  async  armazenaToken(json) {
    const api = new jwtApi.BrowserIdentifier();
      api.storeToken(json);
    }
}
